import React from 'react';
import {
  Grid,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import {
  CustomButton,
  CustomInputLabel,
  CustomTextField,
  InputProps
} from '../../../.././custom/components';
import styles from '../../../../custom/style.module.css';
import docStyles from '../docs.module.css';
import { Stack } from '@mui/system';
import { Search } from '@mui/icons-material';

const awbDoc = (props) => {

  return (
    <Grid container spacing={2} flexWrap='wrap'>
      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
          <CustomInputLabel variant='caption' component='label' className={docStyles.addTextLabel} htmlFor='awb_no' required
            sx={{
              fontSize: '0.75rem',
              color: 'rgba(0, 0, 0, 0.87)',
              fontWeight: 400
            }}
          >Awb Number</CustomInputLabel>
          <div className={docStyles.addTextField}>
            <CustomTextField
              {...InputProps}
              id='awb_no'
              fullWidth
              placeholder='Airwaybill Number'
              type='text'
              name='awb_no'
              onChange={(e) => props.handleChangeForm(e, 'awb_no')}
              value={props.formFields.awb_no || ''}
              className={docStyles.awbIpTextfield}
              error={!props.formFields.awb_no}
              InputProps={{
                classes: {
                  root: docStyles.awbIpRoot,
                  input: docStyles.awbIp
                },
                endAdornment: <InputAdornment position='end'>
                  <IconButton
                    size='small'
                    aria-label='search'
                    edge='end'
                    onClick={() => props.searchAwb()}
                  >
                    <Search fontSize='inherit' />
                  </IconButton>
                </InputAdornment>,
              }}
              InputLabelProps={{ shrink: false }}
            />
          </div>
        </Stack>
      </Grid>

      <Grid item xs={12}>
        <Typography variant='caption' component='div' fontStyle='italic' color='rgba(0, 0, 0, 0.82)' borderBottom='1px solid lightgrey'
        >The following fields are optional.</Typography>
      </Grid>

      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
          <Typography variant='caption' component='label' className={docStyles.addTextLabel} htmlFor='pieces'>Pieces</Typography>
          <div className={docStyles.addTextField}>
            <CustomTextField
              {...InputProps}
              id='pieces'
              fullWidth
              placeholder='Pieces'
              type='text'
              onChange={(e) => props.handleChangeForm(e, 'pcs')}
              value={props.formFields.pcs || ''}
              name='pcs'
            />
          </div>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
          <Typography variant='caption' component='label' className={docStyles.addTextLabel} htmlFor='weight'>Weight</Typography>
          <div className={docStyles.addTextField}>
            <CustomTextField
              {...InputProps}
              id='weight'
              fullWidth
              placeholder='Weight'
              type='text'
              name='wgt'
              onChange={(e) => props.handleChangeForm(e, 'wgt')}
              value={props.formFields.wgt || ''}
              inputProps={{ 'aria-label': 'Weight' }}
            />
          </div>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
          <Typography variant='caption' component='label' className={docStyles.addTextLabel} htmlFor='origin'>Origin</Typography>
          <div className={docStyles.addTextField}>

            <CustomTextField
              {...InputProps}
              id='origin'
              fullWidth
              placeholder='Origin'
              type='text'
              onChange={(e) => props.handleChangeForm(e, 'org')}
              value={props.formFields.org || ''}
              name='org'
            />
          </div>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
          <Typography variant='caption' component='label' className={docStyles.addTextLabel} htmlFor='destination'>Destination</Typography>
          <div className={docStyles.addTextField}>
            <CustomTextField
              {...InputProps}
              id='destination'
              fullWidth
              placeholder='Destination'
              type='text'
              onChange={(e) => props.handleChangeForm(e, 'dest')}
              value={props.formFields.dest || ''}
              name='dest'
            />
          </div>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
          <Typography variant='caption' component='label' className={docStyles.addTextLabel} htmlFor='forwarder'>Forwarder</Typography>
          <div className={docStyles.addTextField}>
            <CustomTextField
              {...InputProps}
              id='forwarder'
              fullWidth
              placeholder='Forwarder'
              type='text'
              name='forwarder'
              onChange={(e) => props.handleChangeForm(e, 'forwarder')}
              value={props.formFields.forwarder || ''}
            />
          </div>
        </Stack>
      </Grid>

      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
          <Typography variant='caption' component='label' className={docStyles.addTextLabel} htmlFor='consignee'>Consignee</Typography>
          <div className={docStyles.addTextField}>
            <CustomTextField
              {...InputProps}
              id='consignee'
              fullWidth
              placeholder='Consignee'
              type='text'
              name='consignee'
              onChange={(e) => props.handleChangeForm(e, 'consignee')}
              value={props.formFields.consignee || ''}
            />
          </div>
        </Stack>

      </Grid>

      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
          <Typography variant='caption' component='label' className={docStyles.addTextLabel} htmlFor='status'>Shipper</Typography>
          <div className={docStyles.addTextField}>
            <CustomTextField
              {...InputProps}
              id='shipper'
              fullWidth
              placeholder='Shipper'
              type='text'
              name='shipper'
              onChange={(e) => props.handleChangeForm(e, 'shipper')}
              value={props.formFields.shipper || ''}
            />
          </div>
        </Stack>
      </Grid>

      <Grid item xs={12} className={`${docStyles.docBtn} ${docStyles.docBtnOnly}`}>
        <CustomButton variant='contained' disabled={!props.docId || props.disableButton} onClick={props.submit}> Update </CustomButton>
      </Grid>
    </Grid>
  );
};

export default awbDoc;